module.exports = __webpack_public_path__ + "img/PL08792.394b487d.png";